import React from 'react';
import { inr, inrCompact } from '../poPayment';

const slug = (s) => String(s).replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase();

function PaymentBar({ row }) {
  const t = row.total || 1;
  return (
    <div className="flex h-1.5 rounded-full overflow-hidden bg-slate-100 mt-1.5" title={`Paid ${inr(row.paid)} · Pending ${inr(row.pending)} · Overdue ${inr(row.overdue)}`}>
      <span className="bg-emerald-500" style={{ width: `${(row.paid / t) * 100}%` }} />
      <span className="bg-amber-400" style={{ width: `${(row.pending / t) * 100}%` }} />
      <span className="bg-red-500" style={{ width: `${(row.overdue / t) * 100}%` }} />
    </div>
  );
}

// Ranked breakdown with a Client / Category switch.
export default function PORankPanel({ byClient, byCategory, onDrill }) {
  const [mode, setMode] = React.useState('client');
  const rows = (mode === 'client' ? byClient : byCategory) || [];
  return (
    <div className="soft-card p-4 sm:p-5 h-full flex flex-col" data-testid="po-rank-panel">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-[#1a1a2e]">Top spend</h3>
        <div className="flex p-0.5 bg-slate-100 rounded-lg">
          {['client', 'category'].map((m) => (
            <button key={m} type="button" onClick={() => setMode(m)}
              className={`px-2.5 py-1 text-xs font-semibold rounded-md capitalize transition-colors ${mode === m ? 'bg-white text-fuchsia-700 shadow-sm' : 'text-slate-600'}`}
              data-testid={`po-rank-mode-${m}`}>By {m}</button>
          ))}
        </div>
      </div>
      <ul className="space-y-1 overflow-y-auto max-h-[420px] -mx-2 px-2">
        {rows.length === 0 && <li className="text-sm text-slate-500 py-6 text-center">Nothing to rank</li>}
        {rows.map((r, i) => (
          <li key={r.key}>
            <button type="button" onClick={() => onDrill({ [mode]: r.key, title: r.label })}
              className="w-full text-left p-2 rounded-xl hover:bg-fuchsia-50/60 transition-colors"
              data-testid={`po-rank-row-${mode}-${slug(r.key)}`}>
              <div className="flex items-center gap-2">
                <span className="w-5 text-[11px] font-bold text-slate-400 tabular-nums">{i + 1}</span>
                <span className="flex-1 truncate text-sm font-medium text-[#1a1a2e]" title={r.label}>{r.label}</span>
                <span className="text-sm font-semibold tabular-nums text-[#1a1a2e]">{inrCompact(r.total)}</span>
              </div>
              <div className="pl-7">
                <div className="flex items-center justify-between text-[11px] text-slate-500 mt-0.5">
                  <span>{r.count} PO{r.count > 1 ? 's' : ''} · {r.share}% share</span>
                  <span>{r.margin_pct == null ? 'no cost data' : `${r.margin_pct}% margin`}</span>
                </div>
                <PaymentBar row={r} />
              </div>
            </button>
          </li>
        ))}
      </ul>
      <div className="flex items-center gap-3 text-[10px] text-slate-500 mt-3 pt-3 border-t border-slate-100">
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-emerald-500" />Paid</span>
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-amber-400" />Pending</span>
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-red-500" />Overdue</span>
      </div>
    </div>
  );
}
